/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathDeltaIcon20Regular = forwardRef('MathDeltaIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.305 18.003c1.502 0 2.468-1.594 1.773-2.926L11.773 2.993c-.747-1.433-2.798-1.433-3.546 0L1.922 15.077c-.695 1.332.271 2.926 1.773 2.926h12.61Zm-2.3-1.601a.75.75 0 0 0 .664-1.097L9.861 6.093a.75.75 0 0 0-1.33 0l-4.808 9.212a.75.75 0 0 0 .665 1.097h9.616Z" })));
});
